export const getInitials = (firstName?: string, lastName?: string): string => {
  const normalizedFirstName = firstName?.trim() ?? '';
  const normalizedLastName = lastName?.trim() ?? '';

  if (!normalizedFirstName && !normalizedLastName) {
    return 'ME';
  }

  return `${normalizedFirstName.charAt(0)}${normalizedLastName.charAt(
    0
  )}`.toUpperCase();
};
